import React from 'react'
import CommonBanner from '../../components/CommonBanner/CommonBanner'
import ServiceSection1 from '../../components/ServiceSection1/ServiceSection1'

// Import necessary components (CommonBanner, ServiceSection1) if not already imported
export default function Services() {
  return (
    <>
      {/* Render the CommonBanner component with the bannerText prop */}
      <CommonBanner bannerText="Our Services" />
      
      {/* Render a div with a class 'honeycomb' for some custom styling */}
      <div className='honeycomb'></div>
      
      {/* Render the first service section */}
      <ServiceSection1 />
    </>
  );
}
